/**
 * QFR Image Comparison — drag handle left/right
 */
(function () {
  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function syncBeforeImageWidth(root) {
    const img = root.querySelector('[data-qfr-compare-before] img');
    if (!img) return;
    img.style.width = root.offsetWidth + 'px';
  }

  function setPosition(root, percent) {
    const p = clamp(percent, 0, 100);
    const before = root.querySelector('[data-qfr-compare-before]');
    const handle = root.querySelector('[data-qfr-compare-handle]');
    if (before) before.style.width = p + '%';
    if (handle) handle.style.left = p + '%';
    root.style.setProperty('--qfr-compare-pos', p + '%');
  }

  function percentFromEvent(root, clientX) {
    const rect = root.getBoundingClientRect();
    if (rect.width <= 0) return 50;
    return ((clientX - rect.left) / rect.width) * 100;
  }

  function initSlider(root) {
    if (root.dataset.qfrCompareInit) return;
    root.dataset.qfrCompareInit = 'true';

    const handle = root.querySelector('[data-qfr-compare-handle]');
    let dragging = false;

    syncBeforeImageWidth(root);
    setPosition(root, 50);

    const onMove = (clientX) => {
      setPosition(root, percentFromEvent(root, clientX));
    };

    const stop = () => {
      dragging = false;
      root.classList.remove('is-dragging');
    };

    root.addEventListener('pointerdown', (e) => {
      if (e.button != null && e.button !== 0) return;
      dragging = true;
      root.classList.add('is-dragging');
      try {
        root.setPointerCapture(e.pointerId);
      } catch (err) {}
      onMove(e.clientX);
      e.preventDefault();
    });

    root.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      onMove(e.clientX);
    });

    root.addEventListener('pointerup', stop);
    root.addEventListener('pointercancel', stop);
    root.addEventListener('lostpointercapture', stop);

    if (handle) {
      handle.addEventListener('keydown', (e) => {
        const step = e.shiftKey ? 10 : 2;
        let current =
          parseFloat(getComputedStyle(root).getPropertyValue('--qfr-compare-pos')) || 50;
        if (e.key === 'ArrowLeft') {
          setPosition(root, current - step);
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          setPosition(root, current + step);
          e.preventDefault();
        } else if (e.key === 'Home') {
          setPosition(root, 0);
          e.preventDefault();
        } else if (e.key === 'End') {
          setPosition(root, 100);
          e.preventDefault();
        }
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-qfr-compare]').forEach((el) => {
      initSlider(el);
      syncBeforeImageWidth(el);
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('[data-qfr-compare]').forEach(syncBeforeImageWidth);
    }, 100);
  });

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));

  if (document.readyState !== 'loading') initAll();
})();
